import HeaderWrapperDesktop from "./header-wrapper-desktop"
import { authStore } from "@/routes/login/auth-store"
import { langStore } from "@/stores/lang-store"
import { useNavigate } from "react-router-dom"
import LogoPart from "./_parts/logo-part"
import { commonBundle } from "./header-const"

const StandardHeaderDesktop = () => {
  const { lang } = langStore()
  const { user_id, role, apiLogout } = authStore()
  const navigate = useNavigate()

  const logoutAction = async () => {
    const success = await apiLogout()

    if (success) navigate("/", { replace: true })
  }

  return (
    <div
      className="border-b border-b-transparent
      hover:bg-white hover:border-b-gray-200 transition-colors duration-300"
    >
      <HeaderWrapperDesktop useBg={false}>
        <div className="flex w-full items-center justify-between">
          <LogoPart />

          <div className="flex items-center gap-1">
            <p className="mr-3 text-sm font-semibold text-slate-700">{user_id}</p>

            {role === "ADMIN" && (
              <button
                type="button"
                onClick={() => navigate("/admin")}
                className="rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-blue-600"
              >
                {commonBundle.admin[lang]}
              </button>
            )}

            <button
              type="button"
              onClick={() => navigate("/my")}
              className="rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-blue-600"
            >
              {commonBundle.myPage[lang]}
            </button>

            <button
              type="button"
              onClick={logoutAction}
              className="rounded-lg px-3 py-2 text-sm font-medium text-slate-400 transition hover:bg-red-50 hover:text-red-500"
            >
              {commonBundle.logout[lang]}
            </button>
          </div>
        </div>
      </HeaderWrapperDesktop>
    </div>
  )
}

export default StandardHeaderDesktop
